import { getPaginated, getApi } from 'util/backendapi/fetch';
import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';

export const areaListDuck = makeReportingDuck(
  'areas',
  (filters) => getPaginated('/reports/areas/', filters),
  () => getApi('/reports/areas/info/')
);

export type AreaListAction = ReportingDuckActions<typeof areaListDuck>;
